import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Contact = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>CONTACT</h1>
                    <Breadcrumb />
                </div>
            </div>

            <div className="container contact-page">

                {/* CONTACT INFO */}
                <div className="contact-info">

                    <div className="contact-card">
                        <h3>📍 Address</h3>
                        <p>NAV JEEVAN MISSION SCHOOL,</p>
                        <p>NAV JEEVAN NAGAR, MEDICAL COLLEGE ROAD, GULHARIYA</p>
                        <p>GORAKHPUR-273013 (U.P.)</p>
                    </div>

                    <div className="contact-card">
                        <h3>📞 Phone</h3>
                        <p>+91-7081803501, +91-7081803502</p>
                    </div>

                    <div className="contact-card">
                        <h3>✉️ Email</h3>
                        <p>njms.gorakhpur@gmail.com</p>
                    </div>

                </div>

                {/* CONTACT FORM */}
                <div className="contact-form">

                    <h2>Send Us a Message</h2>

                    <input type="text" placeholder="Your Name" />
                    <input type="email" placeholder="Your Email" />

                    <textarea placeholder="Your Message"></textarea>

                    <button>Send Message</button>

                </div>


                {/* MAP */}
                <div className="contact-map">
                    <iframe
                        title="map"
                        src="https://www.google.com/maps?q=Nav+Jeevan+Mission+International+School&output=embed"
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        loading="lazy"
                    ></iframe>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Contact;